import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {CustomEmail} from 'types/api/settings/customEmails/customEmail'

export const useUpdateCustomEmail = () => {
  const authAxios = useAuthAxios()
  return async (clientId: string, customMailId: string, data: CustomEmail) =>
    authAxios.patch(`/api/clients/${clientId}/custom_emails/${customMailId}`, data)
}
